// extracted by mini-css-extract-plugin
module.exports = {"root":"product-grid-module--root--3RzJI","headline":"product-grid-module--headline--3YXpI","grid":"product-grid-module--grid--2VnSi"};